import React from "react";
import LockOutlined from "@mui/icons-material/LockOutlined";

import { lockedActions } from "../../../../../components/SettlementLock";
import { LockNote } from "./styles";
import { ProgressLockProps } from "./types";

export const ProgressLock: React.FC<ProgressLockProps> = ({ row, actions }) => {
  if (row.lockLabel === null) {
    return null;
  }
  if (actions && row.transaction) {
    const { settlement, cashbackExpenseId } = row.transaction;
    const { lock } = lockedActions({
      settlement,
      cashbackExpenseId,
      actions: null,
      onOpenExpense:
        cashbackExpenseId == null
          ? undefined
          : () => actions.onOpenExpense(cashbackExpenseId),
    });
    return <>{lock}</>;
  }
  return (
    <LockNote>
      <LockOutlined aria-hidden />
      {row.lockLabel}
    </LockNote>
  );
};
